module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "indexTwo"
    }
  }, [_c('div', {
    staticClass: "waring-head",
    on: {
      "click": _vm.hqGo
    }
  }, _vm._l((_vm.hq.live.tips), function(items) {
    return (items.State == 0) ? _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      }
    }, [_vm._v(_vm._s(items.Content) + " >")]) : _vm._e()
  })), _vm._v(" "), _vm._l((_vm.hq.live.tips), function(items) {
    return (items.State == 1) ? _c('div', {
      staticClass: "warning-main",
      attrs: {
        "id": "markquee"
      }
    }, [_c('div', {
      staticClass: "sqBorder"
    }, [_c('div', {
      staticClass: "scroll_div",
      attrs: {
        "id": "scroll_div"
      }
    }, [_c('div', {
      attrs: {
        "id": "scroll_begin"
      }
    }, [_c('ul', [_c('li', [_vm._v("\n              " + _vm._s(items.Content) + "\n            ")])])]), _vm._v(" "), _c('div', {
      attrs: {
        "id": "scroll_end"
      }
    })])])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "content-main"
  }, [_c('div', {
    staticClass: "main-title"
  }, [_c('div', {
    staticClass: "main-title-desc"
  }, [_vm._v("可提现收益: "), _c('span', {
    staticClass: "can-use-tx"
  }, [_vm._v(_vm._s(_vm.hq.live.availableluckymoney))]), _vm._v("浪票 (税前)")])]), _vm._v(" "), _c('div', {
    staticClass: "able-lang-piao"
  }, [_c('div', {
    staticClass: "can-transfer"
  }, [_c('div', [_vm._v(_vm._s(_vm.hq.live.availablecash))]), _vm._v(" "), _c('div', {
    staticClass: "price-dw"
  }, [_vm._v("元")])])]), _vm._v(" "), _c('div', {
    staticClass: "tx-content"
  }, [_c('div', {
    staticClass: "sui-money"
  }, [_c('div', {
    staticClass: "sui-money-jiao sui-money-jiao-right"
  }, [_c('div', {
    staticClass: "sui-money-desc"
  }, [_vm._v("待结算现金收益")]), _vm._v(" "), _c('div', {
    staticClass: "sui-money-comm"
  }, [_c('span', {
    staticClass: "sui-money-p"
  }, [_vm._v(_vm._s(_vm.hq.live.frozencash))]), _c('span', {
    staticClass: "sy-dw"
  }, [_vm._v("元")])])]), _vm._v(" "), _c('div', {
    staticClass: "sui-money-jiao sui-money-jiao-left"
  }, [_c('div', {
    staticClass: "sui-money-desc"
  }, [_vm._v("累计现金收益")]), _vm._v(" "), _c('div', {
    staticClass: "sui-money-comm"
  }, [_c('span', {
    staticClass: "sui-money-p"
  }, [_vm._v(_vm._s(_vm.hq.live.cashamount))]), _c('span', {
    staticClass: "sy-dw"
  }, [_vm._v("元")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-main hqpord hq-tx-cont"
  }, [_c('div', {
    staticClass: "hq-tx-main",
    on: {
      "click": function($event) {
        _vm.hqporddetail()
      }
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "content-main hqpord hq-tx-cont",
    on: {
      "click": function($event) {
        _vm.financial()
      }
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "bottom-menu"
    }
  }, [_c('div', {
    staticClass: "tiper",
    on: {
      "click": function($event) {
        _vm.hqpordHelp()
      }
    }
  }, [_vm._v("\n      收益结算及提现规则\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "menu-container"
  }, [_c('div', {
    staticClass: "menu-main",
    on: {
      "click": function($event) {
        _vm.showCash()
      }
    }
  }, [_vm._v("\n        我的活期宝\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "menu-main",
    on: {
      "click": function($event) {
        _vm.overTo()
      }
    }
  }, [_vm._v("\n        提现\n      ")])])]), _vm._v(" "), _c('form', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "action": "/LKHqb/CheckFundUserStatus",
      "method": "post",
      "id": "fundForm"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceId),
      expression: "deviceId"
    }],
    attrs: {
      "type": "text",
      "name": "device_id",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.deviceId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deviceId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ctoken),
      expression: "ctoken"
    }],
    attrs: {
      "type": "text",
      "name": "ctoken",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.ctoken)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ctoken = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.utoken),
      expression: "utoken"
    }],
    attrs: {
      "type": "text",
      "name": "utoken",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.utoken)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.utoken = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.targetUrl),
      expression: "targetUrl"
    }],
    attrs: {
      "type": "text",
      "name": "targetUrl",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.targetUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.targetUrl = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.targetType),
      expression: "targetType"
    }],
    attrs: {
      "type": "text",
      "name": "type",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.targetType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.targetType = $event.target.value
      }
    }
  })])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hq-tx-desc"
  }, [_c('img', {
    staticClass: "lc-icon",
    attrs: {
      "src": require("../../assets/images/sy-detail.png")
    }
  }), _vm._v("收益明细")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-main"
  }, [_c('i', {
    staticClass: "mui-icon mui-icon-arrowright right-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hq-tx-main"
  }, [_c('div', {
    staticClass: "hq-tx-desc"
  }, [_c('img', {
    staticClass: "lc-icon",
    attrs: {
      "src": require("../../assets/images/lc-icon-t.png")
    }
  }), _vm._v("基金理财")]), _vm._v(" "), _c('div', {
    staticClass: "right-main"
  }, [_c('span', {
    staticClass: "lc-desc"
  }, [_vm._v("赚钱更轻松")]), _vm._v(" "), _c('i', {
    staticClass: "mui-icon mui-icon-arrowright right-icon"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5adbb728!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/hqpord/index.vue
// module id = 358
// module chunks = 34